import { isString } from '@mbrtargeting/metatag-utils';

export interface Matcher<T> {
    regex: RegExp,
    extract: (match: RegExpMatchArray) => T,
}

export const waitForPostMessage = <DATA>({ regex, extract }: Matcher<DATA>, callback: (data: DATA) => void, once: boolean) => {
    const handler = ({ data }: MessageEvent<unknown>): void => {
        if (!isString(data)) return;
        const match = data.match(regex);
        if (!match) return;
        if (once) cancel();
        callback(extract(match));
    };
    const cancel = () => window.removeEventListener('message', handler);
    window.addEventListener('message', handler);
    return {
        cancel,
    };
};
